<template>
	<div class="settings-container">
		<h1>{{ $t('appbar.settings-menu.CompanyInformation.title') }}</h1>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.name')" label-for="name">
			<b-form-input id="name" v-model="name" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.address1')" label-for="address1">
			<b-form-input id="address1" v-model="primaryAddress.address1" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.address2')" label-for="address2">
			<b-form-input id="address2" v-model="primaryAddress.address2" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.city')" label-for="city">
			<b-form-input id="city" v-model="primaryAddress.city" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.state')" label-for="state">
			<b-form-input id="state" v-model="primaryAddress.state" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.zip')" label-for="zip">
			<b-form-input id="zip" v-model="primaryAddress.zip" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group :label="$t('appbar.settings-menu.CompanyInformation.country')" label-for="country">
			<b-form-input id="country" v-model="primaryAddress.country" :disabled="isDisabled" />
		</b-form-group>
		<b-form-group>
			<b-button variant="primary" @click="saveCompanyInformation">
				{{ $t('appbar.settings-menu.UserInformation.update') }}
			</b-button>
			<b-button @click="resetCompanyInformation">
				{{ $t('appbar.settings-menu.UserInformation.cancel') }}
			</b-button>
		</b-form-group>
	</div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

export default {
	data() {
		return {
			name: null,
			primaryAddress: {
				address1: null,
				address2: null,
				city: null,
				state: null,
				zip: null,
				country: null,
			},
		};
	},
	computed: {
		...mapState(['user']),
		isDisabled: {
			get() {
				return this.user.currentEnterprise.enterprise_user.role !== 'OWNER';
			},
		},
	},
	created() {
		this.getCompanyInformation();
	},
	methods: {
		...mapMutations(['setUser']),
		resetCompanyInformation() {
			this.name = this.user.currentEnterprise.name;
			this.primaryAddress.address1 = this.user.currentEnterprise.primaryAddress.address1;
			this.primaryAddress.address2 = this.user.currentEnterprise.primaryAddress.address2;
			this.primaryAddress.city = this.user.currentEnterprise.primaryAddress.city;
			this.primaryAddress.state = this.user.currentEnterprise.primaryAddress.state;
			this.primaryAddress.zip = this.user.currentEnterprise.primaryAddress.zip;
			this.primaryAddress.country = this.user.currentEnterprise.primaryAddress.country;
		},
		async getCompanyInformation() {
			try {
				const response = await this.axios.get(`/enterprises/${this.user.currentEnterprise.id}`);
				if (response.status === 200) {
					this.name = response.data.name;
					this.primaryAddress = response.data.primaryAddress;
				}
			} catch (error) {
				this.$bvToast.toast(this.$t('appbar.settings-menu.CompanyInformation.error'), {
					title: 'Error',
					variant: 'danger',
				});
			}
		},
		async saveCompanyInformation() {
			try {
				const response = await this.axios.patch(`/enterprises/${this.user.currentEnterprise.id}`, {
					name: this.name,
					primaryAddress: this.primaryAddress,
				});
				if (response.status === 200) {
					// quick update to company name on currentEnterprise
					this.$store.state.user.currentEnterprise.name = this.name;
					this.$bvToast.toast(this.$t('appbar.settings-menu.CompanyInformation.updated'), {
						title: 'Success',
						variant: 'success',
					});
				} else {
					this.$bvToast.toast(this.$t('appbar.settings-menu.CompanyInformation.error'), {
						title: 'Error',
						variant: 'danger',
					});
				}
			} catch (error) {
				this.$bvToast.toast(this.$t('appbar.settings-menu.CompanyInformation.error'), {
					title: 'Error',
					variant: 'danger',
				});
			}
		},
	},
};
</script>

<style scoped>
.settings-container {
	flex: 1;
	overflow-y: auto;
	padding: 1rem;
}

.settings-container::after {
	content: '';
	display: block;
	height: 2rem;
	width: 100%;
}

.profile-photo {
	position: relative;
	border: 1px solid #323232;
	cursor: pointer;
	height: 150px;
	width: 150px;
}

.tan-icon-arrow-up {
	position: absolute;
	right: 5px;
	bottom: 5px;
}

.profile-photo-input {
	display: none;
}
</style>